export default __webpack_public_path__ + "static/media/doctor_male.9f913f04.png";